<template>
  <v-dialog v-model="dialog" max-width="600" lazy>
    <v-card>
      <v-toolbar color="primary" flat dense card dark>
        <v-toolbar-title>
          {{ $t('titles.global.importPlayers') }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="$emit('close')">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider />
      <v-card-text>
        <div>
          <v-layout wrap row pa-3>
            <template v-if="showFilters">
              <v-flex xs12 px-2>
                <entity-field
                  v-model="localEntityId"
                  clearable
                  :label="
                    $t('action.actions.select', {
                      field: $tc('models.entity'),
                    })
                  "
                />
              </v-flex>
              <v-flex xs12 px-2>
                <category-menu
                  v-model="categoryId"
                  clearable
                  :label="
                    $t('action.actions.select', {
                      field: $tc('models.category'),
                    })
                  "
                />
              </v-flex>
            </template>
            <v-flex v-if="!teamId" xs12 px-2>
              <team-field
                v-model="localTeamId"
                :label="
                  $t('action.actions.select', {
                    field: $tc('models.team'),
                  }) + ' (*)'
                "
                :entity-id="entityId || localEntityId"
                :category-id="categoryId"
                clearable
              >
                <v-icon
                  slot="prepend"
                  class="filters"
                  @click="showFilters = !showFilters"
                >
                  tune
                </v-icon>
              </team-field>
            </v-flex>
            <v-flex md6 xs12 px-2>
              <v-switch
                v-model="includesFamiliar"
                :label="$t('titles.global.includesFamiliar')"
                color="primary"
              />
            </v-flex>
          </v-layout>
          <vue-dropzone
            v-if="teamId || localTeamId"
            id="dropzone"
            ref="myVueDropzone"
            :options="dropzoneOptions"
            @vdropzone-sending="sendingEvent"
            @vdropzone-success="onSuccess"
            @vdropzone-error="onError"
            @vdropzone-removed-file="error = ''"
          />
          <v-alert :value="!!error" type="error">
            {{ error }}
          </v-alert>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn small ripple color="primary" @click="downloadImportTemplate">
          {{ $t('action.buttons.downloadTemplate') }}
        </v-btn>
        <meta-button type="cancel" @click="$emit('close')" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import vuetifyToast from 'vuetify-toast'
import CategoryMenu from '@/components/management/categories/CategoryMenu'
import EntityField from '@/components/widgets/Input/EntityField'
import TeamField from '@/components/widgets/Input/TeamField'
import { apiAxios } from '@/helpers'
const _SheetJSFT = ['xlsx', 'xls', 'csv'].map((x) => '.' + x).join(',')
export default {
  name: 'DialogImportUsers',
  components: {
    TeamField,
    EntityField,
    CategoryMenu,
    vueDropzone: vue2Dropzone,
  },
  props: {
    teamId: {
      type: String,
    },
    entityId: {
      type: String,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialog: false,
      localEntityId: '',
      categoryId: '',
      localTeamId: '',
      error: '',
      includesFamiliar: true,
      showFilters: false,
      dropzoneOptions: {
        url: process.env.VUE_APP_API_URL + 'users/import',
        maxFilesize: 5,
        maxFiles: 1,
        acceptedFiles: _SheetJSFT,
        addRemoveLinks: true,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('userToken')}`,
          iso: localStorage.getItem('iso'),
        },
        dictCancelUpload: this.$t('titles.dropzone.dictCancelUpload'),
        dictCancelUploadConfirmation: this.$t(
          'titles.dropzone.dictCancelUploadConfirmation'
        ),
        dictRemoveFile: this.$t('titles.dropzone.dictRemoveFile'),
        dictMaxFilesExceeded: this.$t('titles.dropzone.dictMaxFilesExceeded'),
        dictResponseError: this.$t('titles.dropzone.dictResponseError'),
        dictInvalidFileType: this.$t('titles.dropzone.dictInvalidFileType'),
        dictFileTooBig: this.$t('titles.dropzone.dictFileTooBig'),
        dictDefaultMessage: this.$t('titles.dropzone.dictDefaultMessage'),
      },
    }
  },
  mounted() {
    setTimeout(() => {
      this.dialog = true
    }, 100)
  },
  methods: {
    downloadImportTemplate() {
      apiAxios
        .get('users/downloadImportTemplate', { responseType: 'blob' })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `import-users-template.xlsx`) // or any other extension
          document.body.appendChild(link)
          link.click()
        })
    },
    onSuccess(file, response) {
      vuetifyToast.show({
        text: response.message,
        color: 'success',
        timeout: 2000,
        icon: 'check',
      })
      this.$emit('success')
      this.$emit('close')
    },
    onError(file, response) {
      this.error =
        typeof response === 'object'
          ? response.message || response.error
          : response
      vuetifyToast.show({
        text: this.error,
        color: 'error',
        timeout: 2000,
        icon: 'warning',
      })
    },
    sendingEvent(file, xhr, formData) {
      formData.append('teamId', this.teamId || this.localTeamId)
      formData.append('includesFamiliar', this.includesFamiliar)
    },
  },
}
</script>
<style>
.dropzone .dz-preview.dz-error .dz-error-message {
  display: none !important;
}
.vue-dropzone > .dz-preview .dz-remove {
  opacity: 1 !important;
}
.filters {
  color: black !important;
}
.filters:hover {
  color: var(--v-primary-base) !important;
}
</style>
